import * as React from 'react';
import './App.css';
import { ResolutionString } from './charting_library/charting_library';
import { TVChartContainer } from './components/TVChartContainer/index';

class App extends React.Component {
    render() {
        return (
            <div className={ 'App' }>
                <TVChartContainer
                    interval={'5' as ResolutionString}
                    symbol={'BTCUSDT'}	
                />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx